import React from "react";
import { Table, Button, Pagination } from "antd";
import styles from "./index.module.less";
import _ from "lodash";

const TableTemplete = ({
  operateColumn,
  editColumn,
  searchService,
  tableProps,
  tableRef,
  setColumns,
}) => {
  const [page, changePage] = React.useState(1);
  const [pageSize, changePageSize] = React.useState(10);
  const [total, changeTotal] = React.useState(0);
  const [loading, changeLoading] = React.useState(false);
  const [dataSource, changeDataSource] = React.useState([]);
  const [columns, changeColumns] = React.useState([]);
  const [otherParams, changeOtherParams] = React.useState({});
  const [isShowPage, changeIsShowPage] = React.useState(false);
  // 暴露组件的方法
  React.useImperativeHandle(tableRef, () => ({
    onSearch,
  }));
  const onSearch = (params) => {
    if (page > 1) {
      changePage(1);
    }
    search({
      ...params,
      page: 1,
    });
  };
  const search = async (params) => {
    changeOtherParams(params);
    const searchParams = {
      page,
      pageSize,
      ...params,
    };
    console.log("searchParams", searchParams);
    changeLoading(true);
    const res = await searchService(searchParams);
    changeLoading(false);
    const columns = [...res.data.columns];
    if (operateColumn) {
      columns.unshift(operateColumn);
    }
    if (editColumn) {
      columns.forEach((item) => {
        if (editColumn[item.dataIndex]) {
          item.render = editColumn[item.dataIndex];
        }
      });
    }
    if (res.data.page >= 0 && res.data.pageSize >= 0 && res.data.total >= 0) {
      changeIsShowPage(true);
      changePage(res.data.page);
      changePageSize(res.data.pageSize);
      changeTotal(res.data.total);
      changeDataSource(res.data.data);
      changeColumns(res.data.columns);
    } else {
      changeIsShowPage(false);
    }
    changeDataSource(res.data.data);
    changeColumns(columns);
  };
  const onChangePage = (_page, _pageSize) => {
    changePage(_page);
    changePageSize(_pageSize);
    search({
      ...otherParams,
      page: _page,
      pageSize: _pageSize
    })
  };
  return (
    <div className={styles["table-templete-outer"]}>
      <Table
        dataSource={dataSource}
        columns={setColumns ? setColumns(columns) : columns}
        loading={loading}
        bordered
        rowKey="id"
        size="small"
        pagination={
          isShowPage && {
            showQuickJumper: true,
            current: page,
            pageSize: pageSize,
            total: total,
            onChange: onChangePage,
            showTotal: (total, range) => `总共 ${total} 条`,
            pageSizeOptions: [10, 20, 50, 100],
            showSizeChanger: true,
          }
        }
        {...tableProps}
      />
    </div>
  );
};

// export default React.forwardRef(TableTemplete)
export default TableTemplete;
